export const visitTypeOptions = [
  {
    value: '1',
    label: 'Первичный'
  },
  {
    value: '2',
    label: 'Вторичный'
  }
]
export const budgetOptions = [
  {
    value: 'less 1',
    label: 'До 1 000 000'
  },
  {
    value: '1-2.5',
    label: '1 000 000 - 2 500 000'
  },
  {
    value: '2.5-4.5',
    label: '2 500 000 - 4 500 000'
  },
  {
    value: '4.5-6',
    label: '4 500 000 - 6 000 000'
  },
  {
    value: '6-8',
    label: '6 000 000 - 8 000 000'
  },
  {
    value: '8-10',
    label: '8 000 000 - 10 000 000'
  },
  {
    value: '10-15',
    label: '10 000 000 - 15 000 000'
  },
  {
    value: '15+',
    label: 'От 15 000 000'
  }
]
export const approximateBuyOptions = [
  {
    value: 'fewDays',
    label: 'На днях'
  },
  {
    value: 'Week',
    label: 'Неделя'
  },
  {
    value: 'Month',
    label: 'Месяц'
  }
]

export const carOwnershipOptions = [
  {
    value: 1,
    label: 'Есть авто'
  },
  {
    value: 0,
    label: 'Нет авто'
  }
]
